import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "ds_customer_token";
const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${t}` } });
      setUser(data);
    } catch { localStorage.removeItem(TOKEN_KEY); setUser(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    // Handle OAuth return — session_id arrives in the URL hash
    const hash = window.location.hash;
    if (hash && hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
      (async () => {
        try {
          const { data } = await axios.post(`${API}/auth/session`, {}, { headers: { "X-Session-ID": sid } });
          localStorage.setItem(TOKEN_KEY, data.session_token);
          setUser(data.user);
          window.history.replaceState(null, "", "/account");
        } catch { /* ignore */ }
        finally { setLoading(false); }
      })();
      return;
    }
    refresh();
  }, [refresh]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    const t = localStorage.getItem(TOKEN_KEY);
    try { await axios.post(`${API}/auth/logout`, {}, { headers: t ? { Authorization: `Bearer ${t}` } : {} }); } catch { /* ignore */ }
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
  };

  const updateProfile = async (payload) => {
    const t = localStorage.getItem(TOKEN_KEY);
    const { data } = await axios.put(`${API}/auth/profile`, payload, { headers: { Authorization: `Bearer ${t}` } });
    setUser(data);
    return data;
  };

  const token = () => localStorage.getItem(TOKEN_KEY);

  const requestOtp = async (email, name) => {
    await axios.post(`${API}/auth/otp/request`, { email, name });
  };

  const verifyOtp = async (email, code) => {
    const { data } = await axios.post(`${API}/auth/otp/verify`, { email, code });
    localStorage.setItem(TOKEN_KEY, data.session_token);
    setUser(data.user);
    return data.user;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh, updateProfile, token, requestOtp, verifyOtp }}>
      {children}
    </AuthCtx.Provider>
  );
};
